import Head from 'next/head'
import PropTypes from 'prop-types'

import { ButtonLink } from '@/components/Button'
import Products from '@/components/Products'
import { HeadingM, BodyM } from '@/components/Typography'
import { decodeURL } from '@/core/utils/dom/decodeURL'

import InternalErrorIcon from '../images/internal-error'

const InternalError = ({ refreshUrl }: { refreshUrl: string }) => (
  <>
    <Head>
      <title>Erro Interno</title>
    </Head>
    <div className="errorContent ecs-container eu-sm-m et-ta-center">
      <InternalErrorIcon />
      <HeadingM className="eu-sm-s">Ops, algo deu errado.</HeadingM>
      <BodyM className="eu-sm-m">Infelizmente não foi possível carregar essa página.</BodyM>
      <div className="eu-sm-m">
        {refreshUrl && (
          <ButtonLink modifier="solid" size="lg" source={decodeURL(refreshUrl)}>
            Tentar novamente
          </ButtonLink>
        )}
      </div>
      <Products />
    </div>
  </>
)

InternalError.propTypes = {
  refreshUrl: PropTypes.string.isRequired,
}

export default InternalError
